module.exports = "/build/admin/images/mediumtile.de24d33b.png";